// Mock data for the Library CRM demo — no imports, no API calls.

export const MOCK_LIBRARY = {
  name: 'Sunrise Study Hub',
  capacity: 60,
  occupied: 42,
};

export const MOCK_STATS = {
  revenueToday: 4200,
  activeSessions: 42,
  occupancyPct: 70,
  newBookingsToday: 8,
  attendancePct: 85,
};

export const MOCK_SESSIONS = [
  { id: 's1', studentName: 'Arjun Sharma', seatNo: 'A-04', checkInTime: '09:15 AM', plan: 'Monthly' },
  { id: 's2', studentName: 'Priya Verma', seatNo: 'B-11', checkInTime: '09:42 AM', plan: 'Half-Yearly' },
  { id: 's3', studentName: 'Rohit Gupta', seatNo: 'A-07', checkInTime: '10:05 AM', plan: 'Monthly' },
  { id: 's4', studentName: 'Sneha Patel', seatNo: 'C-02', checkInTime: '10:30 AM', plan: 'Weekly' },
  { id: 's5', studentName: 'Karan Mehta', seatNo: 'B-15', checkInTime: '11:00 AM', plan: 'Monthly' },
];

export const MOCK_STUDENTS = [
  { id: 'u1', name: 'Arjun Sharma', plan: 'Monthly', status: 'active', joinedDate: '01 Jan 2025', initial: 'A' },
  { id: 'u2', name: 'Priya Verma', plan: 'Half-Yearly', status: 'active', joinedDate: '15 Feb 2025', initial: 'P' },
  { id: 'u3', name: 'Rohit Gupta', plan: 'Monthly', status: 'expiring', joinedDate: '10 Mar 2025', initial: 'R' },
  { id: 'u4', name: 'Sneha Patel', plan: 'Weekly', status: 'expired', joinedDate: '01 Apr 2025', initial: 'S' },
  { id: 'u5', name: 'Karan Mehta', plan: 'Monthly', status: 'active', joinedDate: '20 Apr 2025', initial: 'K' },
  { id: 'u6', name: 'Divya Nair', plan: 'Half-Yearly', status: 'active', joinedDate: '05 May 2025', initial: 'D' },
  { id: 'u7', name: 'Aditya Singh', plan: 'Monthly', status: 'expiring', joinedDate: '12 May 2025', initial: 'A' },
  { id: 'u8', name: 'Pooja Krishnan', plan: 'Weekly', status: 'active', joinedDate: '18 May 2025', initial: 'P' },
];

export const MOCK_ANALYTICS = {
  days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  revenue: [2800, 3100, 2600, 3500, 4200, 5800, 4900],
  occupancy: [58, 63, 55, 68, 70, 88, 76],
};
